import React from 'react';
import { BrowserRouter, Routes, Route, Link } from 'react-router-dom';
// import Dashboard from './components/Dashboard/Dashboard';
import Dashboard from './components/Dashboard-Mapbox/Dashboard';
import Home from './components/Home/Home';
import Request from './components/Request/Request';
import './App.css';
import 'mapbox-gl/dist/mapbox-gl.css';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/request" element={<Request />} />
        <Route path="*" element={<Home />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
